import React from 'react';
import { useCurrentUser } from '../auth/useCurrentUser';
import { SignOutButton } from '../auth/SignInButton';

export default function ProfilePage() {
  const { profile, email, displayName, tenants, activeTenant, role, isPlatformAdmin } = useCurrentUser();
  return (
    <div style={{ maxWidth: 720, margin: '32px auto', padding: 24 }}>
      <h2 style={{ fontSize: 18, fontWeight: 700, color: '#0D1B2A', marginBottom: 20 }}>Your profile</h2>

      <div style={{ background: '#fff', border: '1px solid #E8ECF0', borderRadius: 10, padding: 20, marginBottom: 20 }}>
        <Row label="Display name" value={displayName || '—'} />
        <Row label="Email" value={email || '—'} />
        <Row label="Pool" value={profile?.poolKind || '—'} />
        <Row label="Platform admin" value={isPlatformAdmin ? 'Yes' : 'No'} />
        <Row label="Active tenant" value={activeTenant || '— (no tenant selected)'} />
        <Row label="Active role" value={role || '—'} />
      </div>

      <div style={{ background: '#fff', border: '1px solid #E8ECF0', borderRadius: 10, padding: 20, marginBottom: 20 }}>
        <div style={{ fontSize: 12, fontWeight: 600, color: '#0D1B2A', marginBottom: 10 }}>
          Tenants ({tenants.length})
        </div>
        {tenants.length === 0 ? (
          <div style={{ fontSize: 11, color: '#7A8899' }}>You have no tenant assignments yet.</div>
        ) : (
          <table style={{ width: '100%', fontSize: 11, borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#F8F9FA' }}>
                <th style={{ padding: '8px', textAlign: 'left', color: '#455A64' }}>Tenant</th>
                <th style={{ padding: '8px', textAlign: 'left', color: '#455A64' }}>Role</th>
                <th style={{ padding: '8px', textAlign: 'left', color: '#455A64' }}>Assigned</th>
              </tr>
            </thead>
            <tbody>
              {tenants.map(t => (
                <tr key={t.tenantId} style={{ borderTop: '1px solid #F0F2F5' }}>
                  <td style={{ padding: '8px' }}>{t.tenantId}</td>
                  <td style={{ padding: '8px' }}>{(t.role || '').toString().toLowerCase()}</td>
                  <td style={{ padding: '8px' }}>{new Date(t.assignedAt).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <SignOutButton />
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div style={{ display: 'flex', padding: '8px 0', borderBottom: '1px solid #F0F2F5', fontSize: 12 }}>
      <div style={{ width: 160, color: '#7A8899' }}>{label}</div>
      <div style={{ flex: 1, color: '#0D1B2A', fontWeight: 500 }}>{value}</div>
    </div>
  );
}
